module.exports = __webpack_public_path__ + "static/img/product_images_big10_h5_zh.2bf3d42.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product_images_big10_h5_zh.png
// module id = u/cx
// module chunks = 34